import Products from "./data/products";
import PgFlavors from "./entities/pgFlavors";
import Loader, { LoaderEvents } from "./loader";
import { AppBase } from "./appBase";

class AppFlavors extends AppBase {
    private _products: Products;
    private _ui: PgFlavors;

    get products() { return this._products; }

    constructor() {
        super();
        this._loader = new Loader();
        this._products = new Products(this.loader);
    }

    override _init() {
        this._langs.init();
        this._header.init();

        this._loader.once(LoaderEvents.Complete, () => this._onLoadDone())
            .load();
    }

    private _onLoadDone(): void {
        document.documentElement.classList.remove("loading");
        window.addEventListener("mousemove", e => this._onMouseMove(e));

        this._ui = new PgFlavors();

        this._animateDom();
    }
}

export const app = new AppFlavors();